import React, { useCallback } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { ProformaTemplateLibraryInDrawer } from '@atlassian/jira-proforma-template-library/src/ui/index.tsx';
import { generateFormTemplateKey } from '@atlassian/jira-proforma-utils/src/common/utils/generate-form-template-key/index.tsx';
import type { TemplateForm } from '@atlassian/proforma-common-core/form-system-models';
import { useRouter } from '@atlassian/react-resource-router';
import { useCreateForm } from '../../services/use-create-form/index.tsx';

type Props = {
	projectId: number;
};

export function FormSettingsTemplateLibrary({ projectId }: Props) {
	const { callCreateForm } = useCreateForm(projectId);
	const [{ location }, { push }] = useRouter();

	const handleTemplateSelectedOld = useCallback(
		async (templateId: string, template: TemplateForm) => {
			const result = await callCreateForm({ templateId, template });

			if (result) {
				push(`${location.pathname}/form/${result.form.id}/edit`);
			}
		},
		[push, callCreateForm, location.pathname],
	);

	const handleTemplateSelected = useCallback(
		async (templateId: string, template: TemplateForm, templateGroup?: string) => {
			const formTemplateKey = generateFormTemplateKey(templateGroup, template.design.settings.name);
			const result = await callCreateForm({ templateId, template, formTemplateKey });

			if (result) {
				push(`${location.pathname}/form/${result.form.id}/edit`);
			}
		},
		[push, callCreateForm, location.pathname],
	);

	return (
		<ProformaTemplateLibraryInDrawer
			onTemplateSelected={
				fg('start-1993_change_granular_template_events')
					? handleTemplateSelected
					: handleTemplateSelectedOld
			}
		/>
	);
}
